import { APIError } from '../models'
import { Plan, IPlan } from '../models/Plan'
import APIService from './APIService'

export interface IServiceConfig {
  [key: string]:
    | string
    | number
    | null
    | undefined
    | Plan[]
    | ((serviceConfig: IServiceConfig | null) => void)
}

/**
 * Service fetching current service configuration from API.
 */
class ServiceConfigService {
  static async getServiceConfig(): Promise<
    IServiceConfig | APIError<unknown> | null
  > {
    const response = await APIService.get('/service')
    if (response instanceof APIError) {
      return response
    }
    const formattedResponse = {
      ...response.data,
      plans: response.data.plans
        ? response.data.plans.map((p: IPlan) => new Plan(p))
        : null,
    }
    return formattedResponse
  }
}

export default ServiceConfigService
